import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Product Details")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Update Product")
const _hoisted_6 = { class: "card-body pt-3" }
const _hoisted_7 = { class: "mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-4" }, "Billing Address:", -1)
const _hoisted_9 = { class: "d-flex flex-wrap py-5" }
const _hoisted_10 = { class: "flex-equal me-5" }
const _hoisted_11 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400 min-w-175px w-175px" }, "Bill to:", -1)
const _hoisted_13 = { class: "text-gray-800 min-w-200px" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" e.smith@kpmg.com.au")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Customer Name:"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "Emma Smith")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Address:"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, " Floor 10, 101 Avenue of the Light Square, New York, NY, 10050. ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Phone:"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "(555) 555-1234")
], -1)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-equal\"><table class=\"table fs-6 fw-bold gs-0 gy-2 gx-2 m-0\"><tr><td class=\"text-gray-400 min-w-175px w-175px\"> Subscribed Product: </td><td class=\"text-gray-800 min-w-200px\"><a href=\"#\" class=\"text-gray-800 text-hover-primary\">Basic Bundle</a></td></tr><tr><td class=\"text-gray-400\">Subscription Fees:</td><td class=\"text-gray-800\">$149.99 / Year</td></tr><tr><td class=\"text-gray-400\">Billing method:</td><td class=\"text-gray-800\">Annually</td></tr><tr><td class=\"text-gray-400\">Currency:</td><td class=\"text-gray-800\">USD - US Dollar</td></tr></table></div>", 1)
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-4" }, "Subscribed Products:", -1)
const _hoisted_21 = { class: "table-responsive" }
const _hoisted_22 = { class: "table align-middle table-row-dashed fs-6 gy-4 mb-0" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom border-gray-200 text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Product"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Subscription ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Qty"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end min-w-70px" }, "Actions")
  ])
], -1)
const _hoisted_24 = { class: "fw-bold text-gray-800" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "w-150px" }, "Basic Bundle"),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-normal text-gray-600" }, "Basic yearly bundle")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-danger" }, "sub_4567_8765")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "1", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, "$149.99 / Year", -1)
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_31 = { class: "svg-icon svg-icon-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "w-150px" }, "Pro Bundle"),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-normal text-gray-400" }, "Basic yearly bundle")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-danger" }, "sub_4567_3433")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, "5", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, "$949.99 / Year", -1)
const _hoisted_36 = { class: "text-end" }
const _hoisted_37 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_38 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_UserMenu = _resolveComponent("UserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/subscriptions/add",
          class: "btn btn-light-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: "/subscriptions/view",
                    class: "text-gray-800 text-hover-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ])
              ]),
              _hoisted_15,
              _hoisted_16,
              _hoisted_17
            ])
          ]),
          _hoisted_18
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("table", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("tbody", _hoisted_24, [
              _createElementVNode("tr", null, [
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _createElementVNode("td", _hoisted_29, [
                  _createElementVNode("a", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
                    ])
                  ]),
                  _createVNode(_component_UserMenu)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_32,
                _hoisted_33,
                _hoisted_34,
                _hoisted_35,
                _createElementVNode("td", _hoisted_36, [
                  _createElementVNode("a", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
                    ])
                  ]),
                  _createVNode(_component_UserMenu)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}